import { AxiosRequestHeaders } from 'axios';

export const HEADERS: AxiosRequestHeaders = {
  accept: 'application/json',
  'Content-Type': 'application/json',
};
